import template from './adpSelect.html';
import controller from './adpSelect.controller';
import './adpSelect.less';

let adpSelectComponent = {
  restrict: 'E',
  bindings: {
    label: "@",
    placeholder: "@",
    isRequired: "<",
  },
  template,
  controller
};

export default adpSelectComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpSelect/adpSelect.component.js